import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import PortalNav from './components/PortalNav';
import NovaArkFooter from './components/NovaArkFooter';
import { Box, Container, Paper, Typography } from '@mui/material';
import PrivacyPolicy from './components/Compliance/PrivacyPolicy';
import Terms from './components/Compliance/Terms';
import IntercomTermsOfUsage from './components/Compliance/Intercom/TermsOfUsage';
import IntercomPrivacyPolicy from './components/Compliance/Intercom/PrivacyPolicy';

const Home = () => (
  <Container>
    <Typography
      variant="h4"
      textAlign="left"
      sx={{
        fontWeight: 700,
        fontSize: { xs: '0.875rem', sm: '1rem' },
        textTransform: "uppercase",
        letterSpacing: 2,
        mt: 4,
        mb: 2,
        color: "#2253A2",
      }}
    >
      Evolution of NOVAARK TECH LABS
    </Typography>

    <Paper
      elevation={3}
      sx={{
        borderRadius: 3,
        overflow: "hidden",
        height: "80vh",
      }}
    >
      <iframe
        src="https://docs.google.com/presentation/d/e/2PACX-1vSBD_-3TwiIZVFbJ5leUAV_0vK7C-BJAGw-SeVSGSwSf8wt52e00qA5H_VPZA27mWkOPUC8OoutD939/pubembed?start=true&loop=true&delayms=2000"
        allowfullscreen="true"
        mozallowfullscreen="true"
        webkitallowfullscreen="true"
        style={{ border: "none", width: "100%", height: "97%" }}
        title="NovaArk Tech Labs - Company Presentation"
      />
    </Paper>
  </Container>
);

const theme = createTheme({
  typography: {
    fontFamily: '"Plus Jakarta Sans", sans-serif',
  },
  palette: {
    primary: {
      main: '#2253A2',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Box display="flex" flexDirection="column" minHeight="100vh">
          <PortalNav />
          <Box component="main" flex="1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/compliance/terms" element={<Terms />} />
              <Route path="/compliance/privacypolicy" element={<PrivacyPolicy />} />
              <Route path="/intercom/terms" element={<IntercomTermsOfUsage />} />
              <Route path="/intercom/privacypolicy" element={<IntercomPrivacyPolicy />} />
              <Route path="*" element={<Typography sx={{ m: 4 }}>Page not found</Typography>} />
            </Routes>
          </Box>
          <NovaArkFooter />
        </Box>
      </Router>
    </ThemeProvider>
  );
}

export default App;
